import api from "../services/api"
import { $Q, $Qll } from "../utils/query-selector"
import { toggleDataActive } from "../utils/toggle-dataset"
import {
  activeButon,
  assignModels,
  cleanDelayMessage,
  cleanMessage,
  fillSelect,
  initializeMesAlertsMethods,
  manageCssClass,
  mesAlertsSubmit,
  resetFormElements
} from "./mes-alerts"

/**
 * Use this ID to get edit form elements
 */
const id = 'edit'

/**
 * Toggle created to show or hide edit form
 * @param {node} element1
 * @param {node} element2
 * @returns null - stop called
 */
export function toggleCustom(element1, element2) {
  if (!element1 && !element2) return

  if (!element1.classList.contains('hidden') && !element2.classList.contains('isEditForm')) {
    element1.classList.add('hidden')
    element2.classList.add('isEditForm')
  } else {
    element1.classList.remove('hidden')
    element2.classList.remove('isEditForm')
  }
}

/**
 * Validate cases of response to user
 * Delete and update feedbacks
 * General error
 * @param {string} message - variable to validate cases to render feedback
  * @returns null - stop called
 */
function renderFeedback(message) {
  let validation = false;
  const errorContainer = $Q('#js-mes-alerts-delete-response-error')
  const successContainer = $Q('#js-mes-alerts-edit-response')
  const modalDelete = $Q('.mes-alerts__message-delete')
  const form = $Q('#js-mes-alerts-edit-form')

  switch(message) {
    case 'The alert was successfully deleted':
      const successContainerDeleted = $Q('#js-mes-alerts-delete-response')

      manageCssClass({
        element: successContainerDeleted,
        cssClass: 'hidden',
        typeAction: 'remove'
      })

      manageCssClass({
        element: modalDelete,
        cssClass: 'hidden',
        typeAction: 'add'
      })

      validation = true
      break
    case 'Alert correctly updated': // Used in edit (put) component
      if (!successContainer) return;

      manageCssClass({
        element: successContainer,
        cssClass: 'hidden',
        typeAction: 'remove'
      })

      manageCssClass({
        element: form,
        cssClass: 'hidden',
        typeAction: 'add'
      })

      validation = true
      break
    default:
      if (!errorContainer) return;

      manageCssClass({
        element: errorContainer,
        cssClass: 'hidden',
        typeAction: 'remove'
      })

      manageCssClass({
        element: modalDelete,
        cssClass: 'hidden',
        typeAction: 'add'
      })
      break
  }

  return validation
}

/**
 * Get quantity alerts.
 * Render quantity alerts
 * Disabled or enable create button if there are more than 5 or least
 * @param {number} qtyAlerts - Quantity alerts
 * @returns null - stop called
 * @author Daniel Santos
*/
export function renderQtyAlert(el ,qtyAlerts) {
 if (!el) return
 const btnCreateAlert = $Q('#js-btn-mes-alets-open')

 if (qtyAlerts === 5) {
   manageCssClass({
     element: el,
     cssClass: 'hidden',
     typeAction: 'remove'
   })
   if (btnCreateAlert) btnCreateAlert.disabled = true
 } else {
   manageCssClass({
     element: el,
     cssClass: 'hidden',
     typeAction: 'add'
   })

   if (btnCreateAlert) btnCreateAlert.disabled = false
 }
}

/**
 * Create a web component to mes alerts in my account
 * This component get all alerts, update and delete
 */
class MesAlertsAccount extends HTMLElement {
  constructor() {
    super()
    this.validateToCallComponent()
  }

  /**
   * Here call the most methods and elements (html)
   */
  initComponent() {
    this.getAlerts()
    this.qtyAlertsElement = $Q('#js-mes-alerts-account-qty')
    this.contentElement = $Q('#js-mes-alerts-content', this)
    this.contentItems = $Q('#js-mes-alerts-items', this)
    this.openValidationDelete = $Q('#js-mes-alerts-delete-confirm')
    this.deleteBtn = $Q('#js-item-alert-delete')
    this.rejectDeleteBtn = $Q('#js-mes-alerts-delete-close')
    this.formEditContainer = $Q('#js-mes-alerts-account-controls')
    this.returnTableBtn = $Q('#js-mes-alerts-account-return')
    this.validateDeleteAlert();
    this.deleteAlert()
    this.submitEdit()
    this.returnTable()
    this.shadowClickToCreateAlert()
    // Load assign model to edit lógic
    assignModels(id)

    // Load create alert lógic
    initializeMesAlertsMethods()
  }

  /**
   * Listen account sidebar to know if mes-alerts item is active.
   * It if active initial component.
   * Render loader and remove loader
   * @author Daniel Santos
   */
  validateToCallComponent() {
    const currentStep = $Q('.account-sidebar__item[data-id="alert"]')

    const observer = new MutationObserver((mutationList, observer) => {
      const { attributeName, target } = mutationList[0]
      if (attributeName === 'class') {
        if (target.classList.contains('active')) {
          const generalLoader = $Q('.mes-alerts-account__container > .loading')

          this.initComponent()

          setTimeout(() => {
            if (generalLoader) generalLoader.remove()
          }, 500)
          observer.disconnect()
        }
      }
    })

    observer.observe(currentStep, {
      attributes: true
    })
  }

  /**
   * Call two time resetFormElements, but diferente parameters to get status required
   * @author Daniel Santos
   */
  resetEditFormElements() {
    resetFormElements(false, id)
    resetFormElements(true, id)
  }

  /**
   * Use toggleCustom to show or hide edit form and reset form.
   * @see toggleCustom
   * @see resetEditFormElements
   * @author Daniel Santos
   */
  toggleComponents() {
    toggleCustom(this.contentElement, this.formEditContainer)
    this.resetEditFormElements()
  }

  /**
   * Come back to alerts table
   * @see toggleComponents
   * @returns null - stop called
   * @author Daniel Santos
   */
  returnTable() {
    if (!this.returnTableBtn) return;

    this.returnTableBtn.addEventListener('click', this.toggleComponents.bind(this))
  }

  /**
   * Open modal to confirm if user wants delete alert or not
   * This button is in form and open modal.
   * Button in modal if delete alert
   * @author Daniel Santos
   */
  validateDeleteAlert() {
    toggleDataActive('#js-mes-alerts-delete-open-confirm', '#js-mes-alerts-delete-confirm', {
      overlay: true,
      closeSelector: '#js-mes-alerts-delete-close',
      blockScroll: true,
    });
  }

  /**
   * Remove css class to an element HTML
   * @param {node} element
   * @returns null - stop called
   */
  restoreComponents(element)  {
    if (!element) return

    if (element.classList.contains('hidden')) element.classList.remove('hidden')
  }


  /**
   * Delete alert
   * Listen event click to start delete process
   * Update alerts table
   * @returns null - stop called
   */
  deleteAlert() {
    if (!this.deleteBtn) return

    this.deleteBtn.addEventListener('click', async () => {
      try {
        const modalDelete = $Q('.mes-alerts__message-delete')
        const modalDeleteClosed = $Q('#overlay--js-mes-alerts-delete-confirm')
        this.deleteBtn.disabled = true
        this.rejectDeleteBtn.disabled = true
        const loader = document.createElement('div')
        loader.classList.add('loading')
        modalDelete.append(loader)

        const { message } = await api.deleteAlertDataVintegaAPI({
          url: `/customers/${this.dataset.customerId}/alerts/${this.deleteBtn.dataset.cod}`
        })

        // If there is a error than render message
        if (!renderFeedback(message)) {
          cleanDelayMessage(id)
          return
        }

        // Update alerts table
        this.getAlerts()

        setTimeout(() => {
          loader.remove()
          modalDeleteClosed.click()
          cleanMessage(id)
          this.toggleComponents()
          this.restoreComponents(modalDelete) // Restore mesaage delete
          this.deleteBtn.disabled = false
          this.rejectDeleteBtn.disabled = false
          window.scroll(0,0)
        }, 1000)
      } catch(error) {
        console.log({ error })
        loader.remove()
        renderFeedback(error.response.data.message)
        cleanDelayMessage(id)
        this.deleteBtn.disabled = false
        this.rejectDeleteBtn.disabled = false
      }
    })
  }

  /**
   * Empty state button to create alert does virtual click to create alert button.
   * @returns null - stop called
   * @author Daniel Santos
   */
  shadowClickToCreateAlert() {
    const emptyStateBtn = $Q('#mes-alerts-empty-btn')
    const createAlertBtn = $Q('#js-btn-mes-alets-open')

    if (!emptyStateBtn || !createAlertBtn) return

    emptyStateBtn.addEventListener('click', () => {
      createAlertBtn.click()
    })
  }

  /**
   * Render empty state
   * @see getAlerts
   * @returns null - stop called
   * @author Daniel Santos
   */
  renderEmptyState() {
    const emptyState = $Q('#js-mes-alerts-empty-state')

    if (!emptyState) return

    manageCssClass({ element: emptyState, cssClass: 'hidden', typeAction: 'remove' })
    manageCssClass({ element: this, cssClass: 'hidden', typeAction: 'add' })
  }

  /**
   * Get alerts of customer
   * @returns null - stop
   * @author Daniel Santos
   */
  async getAlerts() {
    try {
      const data = await api.getDataVintegaAPI({
        url: `/customers/${this.dataset.customerId}/alerts`
      })

      if (!data.length) {
        this.renderEmptyState()
        return
      } else {
        manageCssClass({
          element: this,
          cssClass: 'hidden',
          typeAction: 'remove'
        })
      }

      // Clean node
      this.contentItems.innerHTML = ''

      data.forEach((item) => {
        item.customerId = this.dataset.customerId
        item.textsComponent = JSON.parse(this.dataset.textsComponent)
        this.contentItems.append(new ItemAlert(item, this.contentElement))
      })

      renderQtyAlert(this.qtyAlertsElement, data.length ? data.length : 0)
    } catch(error) {
      console.error({ error })
    }
  }

  /**
   * Edit alert submit
   * @author Daniel Santos
   */
  submitEdit() {
    mesAlertsSubmit(
      /**
       * Update alert and render feedback
       * Restore elements
       * @param {string} customerId - Customer id
       * @param {object} payload - Objecto to send
       * @param {node} submitBtn - Submitter
       * @returns {string} response request
       * @author Daniel Santos
       */
      async (customerId, payload, submitBtn) => {
        this.returnTableBtn.disabled = true

        const { message } = await api.updateDataVintegaAPI({
          url: `/customers/${customerId}/alerts/${submitBtn.dataset.cod}`,
          payload
        })

        renderFeedback(message)
        this.getAlerts()
        this.returnTableBtn.disabled = true

        setTimeout(() => {
          this.toggleComponents()
          activeButon(submitBtn, id)
          this.resetEditFormElements()
          this.returnTableBtn.disabled = false
        }, 2000)

        return message
      },
      id
    )
  }

}

customElements.define('mes-alerts-account', MesAlertsAccount)

/**
 * Web component to alert items
 */
export class ItemAlert extends HTMLElement {
  /**
   * Get main nodes and methods
   * @param {object} data - Alert data
   * @param {node} parent - Table parent
   */
  constructor(data, parent) {
    super()
    this.elementParent = parent
    this.formEditContainer = $Q('#js-mes-alerts-account-controls')
    this.deleteBtn = $Q('#js-item-alert-delete')
    this.currentAlertCodeElement = $Q('#js-mes-alerts-current span')
    this.editSubmit = $Q('#js-mes-alerts-edit-form button[type="submit"]')
    this.data = data
    this.renderItemAlert()
    this.openEditAlert()
  }

  /**
   * Fill edit form with values already added.
   * @param {object} data
   * @returns
   */
  setSelectValues(data) {
    const selects = $Qll('#js-mes-alerts-edit-form select')

    if (!selects.length) return;
    let i = 0

    while (i < selects.length) {
      selects[i].value = data[selects[i].name]

      if (selects[i].name === 'designer') {
        fillSelect(selects[i].value, selects[i], id)
      }

      i++
    }
  }

  /**
   * Render form to edit and delete alert
   * Init feature of alerts form
   * @returns null - stop called
   */
  openEditAlert() {
    const openEditBtn = $Q('#js-item-alert-edit', this)

    if (!openEditBtn) return
    openEditBtn.dataset.cod = this.data.cod

    openEditBtn.addEventListener('click', () => {
      toggleCustom(this.elementParent, this.formEditContainer)
      this.deleteBtn.dataset.cod = this.data.cod
      this.editSubmit.dataset.cod = this.data.cod
      this.currentAlertCodeElement.innerHTML = `#${this.data.cod}`
      this.setSelectValues(this.data)
      window.scroll(0,0)
    })
  }

  /**
   * Alert id base is 000
   * It replaces position validating id length
   * @param {number} id - Alert id
   * @returns string
   */
  parseAlertId(id) {
    if (id >= 10) return `0${id}`
    if (id < 10) return `00${id}`

    return`${id}`
  }

  /**
   * Clean condition word
   * @param {string} condition
   * @returns string
   */
  parseCondition(condition) {
    const conditionParsed = condition ? condition.toLowerCase() : condition
    return conditionParsed &&
      conditionParsed.includes('etat_') ? conditionParsed.split('etat_')[1] : conditionParsed
  }

  /**
   * Create item alert component
   * @returns
   */
  createItemContent() {
    const {
      cod,
      designer,
      model,
      color,
      material,
      condition,
      textsComponent
    } = this.data

    const parseCondition = this.parseCondition(condition)

    return `
      <div class="mes-alerts-account__table-code-alert" data-alert-id="${cod}">
        <span>
          #${cod ? this.parseAlertId(cod) : ''}
        </span>
      </div>

      <div class="mes-alerts-account__table-item">
        <div class="mes-alerts-account__table-subitem">
          <span>${textsComponent.designer}:</span>
          <span>${designer ? designer : '---'}</span>
        </div>
        <div class="mes-alerts-account__table-subitem">
          <span>${textsComponent.model}:</span>
          <span>${model ? model : '---'}</span>
        </div>
        <div class="mes-alerts-account__table-subitem">
          <span>${textsComponent.color}:</span>
          <span>${color ? color : '---'}</span>
        </div>
        <div class="mes-alerts-account__table-subitem">
          <span>${textsComponent.material}:</span>
          <span>${material ? material: '---'}</span>
        </div>
        <div class="mes-alerts-account__table-subitem">
          <span>${textsComponent.condition}:</span>
          <span>${parseCondition ? parseCondition : '---'}</span>
        </div>
      </div>

      <div class="mes-alerts-account__edit">
        <button class="btn-2" id="js-item-alert-edit">
          ${textsComponent.edit}
        </button>
      </div>
    `
  }

  renderItemAlert() {
    this.innerHTML = this.createItemContent()
  }
}

customElements.define('item-alert', ItemAlert)
